// import * as types from '../types';
import { ActionContext, ActionTree, GetterTree } from "vuex";
import { InspectKbn, SeibiKbn } from "@/model/InspectKbn";
import { InspectStaff } from "@/model/InspectStaff";
import { LiftUse } from "@/model/LiftUse";

// 整備士と補助整備士の合計選択上限値：3人(車検開始前基準値)
const DEFAULT_MAX_SEIBISHI_HOJO_STAFF_COUNT = 3;

export interface InspectionNowSelectedState {
  nowSelected: { [key: string]: boolean };
}

export interface InspectionDetailState extends InspectionNowSelectedState {
  inspectLine: InspectKbn[];
  liftUse: LiftUse[];
  shakenShurui: SeibiKbn[];
  staffHojo: InspectStaff[];
  staffKensain: InspectStaff[];
  staffSeibishi: InspectStaff[];
  hasData: boolean;
  configurationBaseline: any;
  stateId: number;
  stateNm: string;
  inspectLineCd: string;
  shakenShuruiSeibiMenuCd: string;
  jizen: InspectKbn[];
  jizenCd: string;
  maxSeibishiHojoStaffCount: number;
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  shakenShuruiNm: string;
  shakenShuruiSeibiMenuUpdatedAt: string;
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
}

/**
 * 想定の構造
 * nowSelected: {
 *   "shakenShurui"  : false,
 *   "jizen"         : false,
 *   "inspectLine"   : false,
 *   "liftUse"       : false,
 *   "staffKensain"  : false,
 *   "staffSeibishi" : false,
 *   "staffHojo"     : false
 * };
 * ここで固定構造で宣言するのではなくaddNowSelected()で構造を追加初期化するイメージ
 * falseは初期値。
 * addNowSelected("string") → nowSelected: {"string": false}
 */
const initialNowSelectedState: InspectionNowSelectedState = {
  nowSelected: {}
};


const initialState: InspectionDetailState = {
  ...initialNowSelectedState,
  inspectLine: [],
  liftUse: [],
  shakenShurui: [],
  staffHojo: [],
  staffKensain: [],
  staffSeibishi: [],
  stateId: 0,
  stateNm: "",
  hasData: false,
  configurationBaseline: null,
  inspectLineCd: "",
  shakenShuruiSeibiMenuCd: ""
  , jizen: []
  , jizenCd: ""
  , maxSeibishiHojoStaffCount: DEFAULT_MAX_SEIBISHI_HOJO_STAFF_COUNT
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  , shakenShuruiNm: ""
  , shakenShuruiSeibiMenuUpdatedAt: ""
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
};

const actions: ActionTree<InspectionDetailState, any> = {
  setConfigurationBaseline({ commit }, payload: any) { commit("setConfigurationBaseline", payload); },
  setInspectLine(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setInspectLine", payload);
  },
  setLiftUse(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setLiftUse", payload);
  },
  setShakenShurui(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setShakenShurui", payload);
  },
  addNowSelected(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("addNowSelected", payload);
  },
  setNowSelected(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setNowSelected", payload);
  },
  setStaffHojo(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setStaffHojo", payload);
  },
  setStaffKensain(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setStaffKensain", payload);
  },
  setStaffSeibishi(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setStaffSeibishi", payload);
  },
  save({ commit }: ActionContext<InspectionDetailState, any>): void {
    commit("save");
  },
  setProgressState(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: { stateId: number; stateNm: string }
  ): void {
    commit("setProgressState", payload);
  },
  clearState({ commit }: ActionContext<InspectionDetailState, any>): void {
    commit("clearState");
  },
  setInspectLineCd(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setInspectLineCd", payload);
  },
  setSeibiMenuCd(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setSeibiMenuCd", payload);
  }
  , setJizen(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setJizen", payload);
  }
  , setJizenCd(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setJizenCd", payload);
  }
  , setMaxSeibishiHojoStaffCount(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setMaxSeibishiHojoStaffCount", payload);
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  , setShakenShuruiNm(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setShakenShuruiNm", payload);
  }
  , setShakenShuruiSeibiMenuUpdatedAt(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setShakenShuruiSeibiMenuUpdatedAt", payload);
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
};

const mutations = {
  setConfigurationBaseline(state: InspectionDetailState, payload: any) { state.configurationBaseline = payload; },
  setInspectLine(state: InspectionDetailState, payload: InspectKbn[]) {
    state.inspectLine = payload;
  },
  setLiftUse(state: InspectionDetailState, payload: LiftUse[]) {
    state.liftUse = payload;
  },
  setShakenShurui(state: InspectionDetailState, payload: SeibiKbn[]) {
    state.shakenShurui = payload;
  },
  addNowSelected(state: InspectionDetailState, payload: string) {
    state.nowSelected = {
      ...state.nowSelected,
      [payload]: false
    };
  },
  setNowSelected(
    state: InspectionDetailState,
    payload: { key: string; value: boolean }
  ) {
    if (
      state.nowSelected[payload.key] === true ||
      state.nowSelected[payload.key] === false
    ) {
      state.nowSelected = {
        ...state.nowSelected,
        [payload.key]: payload.value
      };
    }
  },
  setStaffHojo(state: InspectionDetailState, payload: InspectStaff[]) {
    state.staffHojo = payload;
  },
  setStaffKensain(state: InspectionDetailState, payload: InspectStaff[]) {
    state.staffKensain = payload;
  },
  setStaffSeibishi(state: InspectionDetailState, payload: InspectStaff[]) {
    state.staffSeibishi = payload;
  },
  save(state: InspectionDetailState) {
    state.hasData = true;
  },
  setProgressState(
    state: InspectionDetailState,
    payload: { stateId: number; stateNm: string }
  ) {
    if (payload.stateId === 0 || payload.stateId) {
      state.stateId = payload.stateId;
      state.stateNm = payload.stateNm;
    }
  },
  clearState(state: InspectionDetailState) {
    Object.assign(state, { ...initialState });
  },
  setInspectLineCd(state: InspectionDetailState, payload: string) {
    state.inspectLineCd = payload;
  },
  setSeibiMenuCd(state: InspectionDetailState, payload: string) {
    state.shakenShuruiSeibiMenuCd = payload;
  }
  , setJizen(state: InspectionDetailState, payload: InspectKbn[]) {
    state.jizen = payload;
  }
  , setJizenCd(state: InspectionDetailState, payload: string) {
    state.jizenCd = payload;
  }
  , setMaxSeibishiHojoStaffCount(state: InspectionDetailState, payload: number) {
    state.maxSeibishiHojoStaffCount = payload || DEFAULT_MAX_SEIBISHI_HOJO_STAFF_COUNT;
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  , setShakenShuruiNm(state: InspectionDetailState, payload: string) {
    state.shakenShuruiNm = payload;
  }
  , setShakenShuruiSeibiMenuUpdatedAt(state: InspectionDetailState, payload: string) {
    state.shakenShuruiSeibiMenuUpdatedAt = payload;
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
};

const getters: GetterTree<InspectionDetailState, any> = {
  currentState(state: InspectionDetailState) {
    return state;
  },
  getInspectLine(state: InspectionDetailState) {
    const filterData = state.inspectLine.filter(e => e.selected === "1");
    return filterData;
  },
  getLiftUse(state: InspectionDetailState) {
    const filterData = state.liftUse.filter(e => e.selected === "1");
    return filterData;
  },
  getShakenShurui(state: InspectionDetailState) {
    const filterData = state.shakenShurui.filter(e => e.selected === "1");
    return filterData;
  },
  getNowSelected(state: InspectionDetailState) {
    return state.nowSelected;
  },
  getStaffHojo(state: InspectionDetailState) {
    const filterData = state.staffHojo.filter(e => e.selected === "1");
    return filterData;
  },
  getStaffKensain(state: InspectionDetailState) {
    const filterData = state.staffKensain.filter(e => e.selected === "1");
    return filterData;
  },
  getStaffSeibishi(state: InspectionDetailState) {
    const filterData = state.staffSeibishi.filter(e => e.selected === "1");
    return filterData;
  },
  useLine(state: InspectionDetailState): boolean {
    return (
      state.inspectLineCd != "" &&
      state.inspectLineCd != "0" &&
      state.inspectLineCd != "3"
    ); // 3 = no line;
  },
  seibiMenuCd(state: InspectionDetailState) {
    return state.shakenShuruiSeibiMenuCd;
  }
  , getJizen(state: InspectionDetailState) {
    const filterData = state.jizen.filter(e => e.selected === "1");
    return filterData;
  }
  , isDoJizen(state: InspectionDetailState) {
    if (!state.jizenCd) { return false; }
    return (state.jizenCd == "1");
  }
  , maxSeibishiHojoStaffCount(state: InspectionDetailState) {
    return state.maxSeibishiHojoStaffCount || DEFAULT_MAX_SEIBISHI_HOJO_STAFF_COUNT;
  }
  , effectiveMaxSeibishiHojoStaffCount(state: InspectionDetailState) {
    if (state.stateId < 1) {
      return DEFAULT_MAX_SEIBISHI_HOJO_STAFF_COUNT;
    }
    return state.maxSeibishiHojoStaffCount || DEFAULT_MAX_SEIBISHI_HOJO_STAFF_COUNT;
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  , getShakenShuruiNm(state: InspectionDetailState) {
    return state.shakenShuruiNm;
  }
  , getShakenShuruiSeibiMenuUpdatedAt(state: InspectionDetailState) {
    return state.shakenShuruiSeibiMenuUpdatedAt;
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
};

export default {
  namespaced: true,
  state: { ...initialState },
  getters,
  mutations,
  actions
};
